import React from 'react';
import { Link } from 'react-router-dom';
import { SIGNIN } from '../../routes/index';

export default () => {
  return (
    <section className="thirdSection" style={{ marginTop: 40 }}>
      <div className="horizontal-layout">
        <div className="line-horizontal"></div>
      </div>
      <div className="horizontal-layout" style={{ marginTop: 24 }}>
        <p className="text-gray" style={{ margin: 0 }}>
          ¿Ya tienes una cuenta?{' '}
          <span className="text-link">
            <Link to={SIGNIN}>Inicia Sesión</Link>{' '}
          </span>
        </p>
      </div>
    </section>
  );
};
